import { IReduxActionProps } from '@/store/redux/Utils';

export const SHOW_DELETE_ACCOUNT_NOTIFICATION =
  'SHOW_DELETE_ACCOUNT_NOTIFICATION';

export const displayAccountDeleteNotification = (
  show: boolean
): IReduxActionProps => {
  return {
    payload: {
      show,
    },
    type: SHOW_DELETE_ACCOUNT_NOTIFICATION,
  };
};
